import { useEffect, useRef } from 'react'
import { FiX } from 'react-icons/fi'

import { Button } from '~/components/Buttons'
import { Label, Textarea } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import * as S from './styles'

const RejectForm = ({ isPending, onCancel, onSubmit }: RejectFormProps) => {
  const { t } = useAPPTranslation()
  const fieldsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    fieldsRef.current?.querySelector('textarea')?.focus()
  }, [])

  return (
    <S.RejectForm
      data-testid="review-media-modal-reject-form"
      onSubmit={onSubmit}
    >
      <S.RejectFields
        ref={fieldsRef}
        data-testid="review-media-modal-reject-fields"
      >
        <S.RejectFormGroup data-testid="review-media-modal-reject-form-group">
          <Label
            data-testid="review-media-modal-reject-form-group-label"
            htmlFor="note"
            isRequired
          >
            {t('rm:reviewAd.reject.label.message')}
          </Label>
          <small>{t('rm:reviewAd.reject.subtitle.label.message')}</small>
          <Textarea name="note" rows={4} minHeight="7rem" required />
        </S.RejectFormGroup>

        <S.RejectFooter data-testid="review-media-modal-reject-footer">
          <Button
            data-testid="review-media-modal-reject-cancel-button"
            template="transparent"
            type="button"
            onClick={onCancel}
          >
            {t('rm:button.Cancel')}
          </Button>
          <Button
            data-testid="review-media-modal-reject-submit-button"
            template="critical"
            type="submit"
            loading={isPending}
            text={t('rm:button.Reject')}
            iconLeft={<FiX />}
          />
        </S.RejectFooter>
      </S.RejectFields>
    </S.RejectForm>
  )
}

export default RejectForm
